// import { list } from './fontAwesomeList';
import awesomeList from './fontAwesomeList.json';
// import { sequenceIcons } from '../constants';

export const getIconsList = () => awesomeList

/**
 * @name iconsListCreator
 * @function
 * @description Форматирование списка font awesome к формату
 * @return [
 *  {
 *    position: 1,
 *    value: 'fas fa-search',
 *    title: 'Search',
 *    search: ['search']
 *  }
 * ]
 */
// export const iconsListCreator = () => {
//   const stylesToClass = {
//     brands: 'fab',
//     solid: 'fas',
//     regular: 'far',
//     light: 'fal',
//     duotone: 'fad',
//   };
//
//   if (list) {
//     const newList = [];
//     Object.keys(list).forEach((key) => {
//       const item = list[key];
//
//       if (item.styles) {
//         item.styles.forEach((style) => {
//           const position = sequenceIcons.findIndex((awesomeKey) => awesomeKey === key);
//           const defaultObject = {
//             position: position === -1 ? 10000 : position,
//             value: '',
//             title: '',
//             search: [],
//           };
//
//           if (stylesToClass[style]) {
//             defaultObject.value = `${stylesToClass[style]} fa-${key}`;
//             defaultObject.title = item.label;
//
//             if (item.search && item.search.terms && item.search.terms.length) {
//               defaultObject.search = [
//                 ...defaultObject.search,
//                 ...item.search.terms,
//               ];
//               defaultObject.search.push(item.label.toLowerCase());
//             } else {
//               defaultObject.search.push(item.label.toLowerCase());
//             }
//           }
//           newList.push(defaultObject);
//         });
//       }
//     });
//     return newList.sort((a, b) => a.position - b.position)
//   }
//   return false;
// };
